import { ReceiptThemeFormValues } from './types';
import { DefaultAssetsURLs } from 'constants/constants';

export const defaultReceiptTheme: ReceiptThemeFormValues = {
  senderName: '',
  logo: DefaultAssetsURLs.defaultLogo,
  headerImage: '',
  publisherId: '',
  paymentReceiptTemplateName: '',
  refundReceiptTemplateName: '',
  subscriptionReceiptTemplateName: '',
  subscriptionRefundReceiptTemplateName: '',
  supportUrl: null
};
